// extracted by mini-css-extract-plugin
module.exports =  {"searchTag":"SearchTagItem-module_searchTag_a37e8"};